import React, { useEffect,useRef } from "react";
import ClickableCard from "../ClickableCard/ClickableCard";
import classes from "./Button.module.css";

/*
props.className = custom class
props.onClick: onClick event
props.width: width of the button
props.height: height of the button
props.backgroundColor: change button background color
props.children: what's inside the button
*/

const Button = (props) => {
  let refresh;
  const container = useRef(null)

  const mousemove = (event) => {};

  const onMouseOver = (event) => {
    let rect = container.current.getBoundingClientRect();
    let x = event.clientX - rect.left; //x position within the element.
    let y = event.clientY - rect.top; //y position within the element.

    container.current.style.setProperty("--width", `${700}px`);
    container.current.style.setProperty("--top", `${y}px`);
    container.current.style.setProperty("--left", `${x}px`);
  };
  const onMouseOut = (event) => {
    // const container = document.getElementsByClassName(classes.container)[1];
    let rect = container.current.getBoundingClientRect();
    let x = event.clientX - rect.left; //x position within the element.
    let y = event.clientY - rect.top; //y position within the element.
    container.current.style.setProperty("--top", `${y}px`);
    container.current.style.setProperty("--left", `${x}px`);
    container.current.style.setProperty("--width", `0px`);
  };
  return (
    <ClickableCard
      className={classes.container+" "+props.className}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      onClick={props.onClick}
      width={props.width}
      height={props.height}
      ref={container}

      backgroundColor={props.backgroundColor}
    >
      {props.children}
    </ClickableCard>
  );
};
export default Button;
